var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"datos",on:{"dblclick":function($event){//ExportConfigurable(aplicacion);
    _vm.Imagen(_vm.aplicacion)}}},[_vm._v(" DATOS ")])
}
var staticRenderFns = []

export { render, staticRenderFns }